import { Autocomplete, Modal, ModalContent, ModalBody, ModalFooter, AutocompleteItem, Button, Input, ModalHeader, Spinner, Switch, useDisclosure } from "@nextui-org/react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_ADM_KEY, linksUrl } from "../../constants/enum"
import { useEffect, useState } from "react"
import { DataGrid } from "@mui/x-data-grid"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faArrowRight, faCancel, faClose, faEye, faEyeSlash, faPlus, faSave } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"
import AddNewParam from "./AddNewParam"
import { Drawer } from "@mui/material"
import { useNavigate } from "react-router-dom"
//import { makeStyles } from '@mui/styles'


const CreateModSetting = () => {

    const {
        isOpen: isOpenModel,
        onOpen: onOpenModel,
        onOpenChange: onOpenModelChange
    } = useDisclosure();
    const { data: modData, mutate: filterModeList } = usePost({
        url: apiRoute.modeSetting.masterModList,
        queryKey: "getModeList",
    })
    const [gridData, setGridData] = useState([])
    const [isNewModEntry, setIsNewModEntry] = useState(0)
    const [adminKey, setAdminKey] = useState("")
    const [openDrawer, setOpenDrawer] = useState(true)
    const [msgkey, setMsgKey] = useState("")
    const [isVisible, setIsVisible] = useState(false)
    const toggleVisibility = () => setIsVisible(!isVisible)
    const onSuccessTasks = (data) => {
        setGridData(data)
    }
    const { isPending: isPendingModData, isError: isErrorFetch, data = [], mutate: filterModData } = usePost({
        url: apiRoute.modeSetting.fetchModData,
        queryKey: "getModeList",
        onSuccessTasks
    })
    const onSuccessUpate = (data) => {
        setGridData([])
        //  setSelectedMod("")
    }
    const { isPending, isError, mutate: funInUpModSetting } = usePost({
        url: apiRoute.modeSetting.update,
        queryKey: "InUpModeSetting",
        onSuccessTasks: onSuccessUpate
    })

    useEffect(() => {
        filterModeList({ data: {} })
    }, [])
    const handleCancle = () => {

        setGridData([])
    }
    const handleNewParam = (data) => {
        if (!isNewModEntry) {
            if (data) {
                funloadModData(selectedMod.key)
                onOpenModelChange();
            }
        }
        else
            filterModeList({ data: {} })
    }
    const entryModel = () => {
        return (
            <div>
                <Modal
                    isOpen={isOpenModel}
                    onOpenChange={onOpenModelChange}
                    size="md"
                    placement="center"
                    //hideCloseButton={true}
                    isDismissable={false}
                //closeButton={<FontAwesomeIcon icon={faClose} />}

                >
                    <ModalContent>
                        {/* {(onClose) => (
                            <> */}
                        <ModalHeader className="flex flex-row gap-1">
                            {isNewModEntry ? "Add New Mod" : "Add New Parameter"}
                        </ModalHeader>
                        <ModalBody className="overflow-auto ">
                            <div className=" flex items-end gap-2">
                                <AddNewParam isnew_modEntry={isNewModEntry} mod_code={isNewModEntry ? 0 : selectedMod.key} mod_name={isNewModEntry ? '' : selectedMod.value} handleNewParam={handleNewParam} />
                            </div>

                        </ModalBody>

                        {/* </>

                        )} */}
                    </ModalContent>
                </Modal>
            </div>
        )
    }


    const [selectedMod, setSelectedMod] = useState({ key: "", value: "" })
    const handleClickPrev = () => {

    }

    const handleInputChange = (index, e) => {

        const { value } = e.target;
        const newData = [...gridData]
        const updatedData = { ...gridData[index], [gridField.defaultValue]: value }
        newData[index] = updatedData
        setGridData(newData)
    }
    const handleSwitchChange = (index, name, e) => {
        const { checked } = e.target
        const newData = [...gridData]
        const updatedData = { ...gridData[index], [name]: String(checked) }
        newData[index] = updatedData
        setGridData(newData)

    }
    const handleSubmit = (e) => {
        e.preventDefault()
        funInUpModSetting({
            data: {
                data_list: gridData
            }
        })

    }
    const itemGridHeadClass = "bill-grid-style"

    const funloadModData = (param) => {
        filterModData({
            data: {
                mod_code: param
            }
        })
    }
    const handleGetData = () => {
        if (selectedMod.key != "" && selectedMod.key != "0") {
            funloadModData(selectedMod.key)
        }
        else {
            toast.error("Select Mode", {
                position: "top-center"
            })
        }
    }
    const handleAutoCompleteChange = (value) => {
        let param = ''
        const filData = modData.filter((ele) => ele.Mod_Code == value)

        if (filData && filData?.length > 0)
            param = filData[0].ModName

        setSelectedMod({ key: value, value: param })

    }

    const gridField = {
        id: "id",
        modCode: "Mod_Code",
        modName: "ModName",
        parameter: "Parameter",
        visible: "Visible",
        mandatory: "Mandatory",
        defaultValue: "Value"
    }
    const columns = [
        {
            field: gridField.parameter,
            headerName: "Parameter",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className='text-left'>
                    {row[gridField.parameter]}
                </div>
            ),
        },
        {
            field: gridField.visible,
            headerName: "Visible",
            // width: 100,
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="text-center ">
                    <Switch color={"success"}
                        size="sm" isSelected={row[gridField.visible].toUpperCase() === "TRUE" ? true : false} onChange={(e) => handleSwitchChange(row.id - 1, gridField.visible, e)}

                    >

                    </Switch></div>
            ),
        },
        {
            field: gridField.mandatory,
            headerName: "Mandatory",
            // width: 100,
            minWidth: 100,
            flex: 1,
            aling: "center",
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="text-center ">
                    <Switch color={"danger"} size="sm" isSelected={row[gridField.mandatory].toUpperCase() === 'TRUE' ? true : false} onChange={(e) => handleSwitchChange(row.id - 1, gridField.mandatory, e)}>

                    </Switch>
                </div>
            ),
        },
        {
            field: gridField.defaultValue,
            headerName: "Value",
            //  width: 200,
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            aling: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <Input type="text" name={gridField.defaultValue}
                    variant='bordered'

                    value={row[gridField.defaultValue]}
                    className='text-center mt-2'
                    size="sm"
                    onKeyDown={(event) => {
                        if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                            return; // Do nothing
                        } else {
                            event.stopPropagation(); // Prevent other keys from propagating
                        }
                    }}
                    onChange={(e) => handleInputChange(row.id - 1, e)} >
                </Input>
            ),
        },
    ]
    const handleAddNew = () => {
        setIsNewModEntry(0)
        if (selectedMod.key != "" && selectedMod.key != "0") {
            onOpenModelChange()
        }
        else {
            toast.error("Select Mode", {
                position: "top-center"
            })
        }
    }
    const handleAddMod = () => {
        setIsNewModEntry(1)
        onOpenModelChange();
    }
    const hanldeKeyCheck = () => {
        if (adminKey && adminKey != "" && adminKey?.length > 0) {
            if (adminKey == ENUM_ADM_KEY) {
                setMsgKey("")
                setOpenDrawer(false)
            }
            else {
                setMsgKey("Invalid key")
            }

        }

    }
    const navi = useNavigate()
    const hanldeBack = () => {
        navi(linksUrl.dashboard.tradingDashboard)
    }
    if (isPending) {
        return <LoadingCard />
    }
    if (isError) {
        return <ErrorCard />
    }
    return (<div>
        <MainContainer pageName="  Add / Update Mode Setting"
            breadcrumbs={["Software Setting", "Mode Settings"]}

        >
            {/* <Drawer open={openDrawer} anchor="top"  >
                <div className="text-center py-20 h-60">
                    <div className="mx-auto flex justify-center gap-4  mt-2">
                        <Button onPress={hanldeBack} size="sm" variant="shadow" color="primary"
                            endContent={<FontAwesomeIcon icon={faArrowLeft} />} >Back</Button>
                        <Input placeholder="Enter Key "
                            errorMessage={msgkey}
                            isInvalid={msgkey}
                            isRequired size="sm" radius="none" className="max-w-40 "
                            variant="bordered" color="primary"
                            onChange={(e) => setAdminKey(e.target.value)}
                            endContent={
                                <button
                                    className="focus:outline-none"
                                    size="sm"
                                    type="button"
                                    variant="light"
                                    onClick={toggleVisibility}
                                >
                                    {isVisible ? (
                                        <FontAwesomeIcon className="text-xs " icon={faEyeSlash} />
                                    ) : (
                                        <FontAwesomeIcon className="text-xs " icon={faEye} />
                                    )}
                                </button>
                            }
                            type={isVisible ? "text" : "password"}
                        ></Input>
                        <Button onPress={hanldeKeyCheck} size="sm" variant="shadow" color="primary"
                            endContent={<FontAwesomeIcon icon={faArrowRight} />} >Go</Button>
                    </div>
                </div>
            </Drawer> */}
            {entryModel()}
            <div className="gap-5" style={{ textAlign: "right" }}>
                <Button
                    size="sm"
                    color="success"
                    startContent={<FontAwesomeIcon icon={faPlus} />}
                    onPress={handleAddNew}
                    className="mr-5"
                >
                    Add Parameter
                </Button>
                <Button
                    size="sm"
                    color="warning"
                    startContent={<FontAwesomeIcon icon={faPlus} />}
                    onPress={handleAddMod}
                >
                    Add Mod
                </Button>
            </div>
            <div className=" items-end gap-2">
                <form onSubmit={handleSubmit}>
                    <div className=" flex gap-5 my-5">
                        <Autocomplete
                            size="md"
                            name={"Mod_code"}
                            // isInvalid={errors[item.name]}
                            // errorMessage={errors[item.name]}
                            label={"Mode"}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder={"--Select--"}
                            isRequired
                            color="primary"
                            className="max-w-23"
                            isClearable={false}
                            isVirtualized
                            defaultItems={
                                modData && modData?.length > 0 ? modData : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e)
                            }
                            selectedKey={selectedMod.key}
                        >
                            {(list) => (
                                <AutocompleteItem
                                    key={list.Mod_Code}
                                >
                                    {list.ModName}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>

                        <Button color={"danger"} size="sm" variant="shadow" onPress={handleGetData} >Get Data</Button>
                    </div>
                    <div className="w-full text-center">
                        {isPendingModData ? <Spinner size="sm" label="Loading..." color="primary" /> : ""}
                        {gridData && gridData?.length > 0 ? (<div>
                            <DataGrid
                                rows={gridData}
                                columns={columns}
                                editMode="row"
                                width="100%"

                                hideFooterPagination={true}
                                hideFooter={true}
                                columnHeaderHeight={35}
                                rowHeight={48}
                                pageSizeOptions={[]}
                                disableColumnSorting={true}
                                disableColumnMenu={true}
                            ></DataGrid>


                            <div className="justify-center flex gap-5 mt-10">
                                <Button
                                    color="primary"
                                    type="submit"
                                    size="md"
                                    variant="shadow"
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="md"
                                    onPress={handleCancle}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    cancle
                                </Button>
                            </div>
                        </div>) : <h2></h2>
                        }

                    </div>
                </form>
            </div>

        </MainContainer>
    </div>
    )
}
export default CreateModSetting